import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import { DepartmentStore, NewDepartmentModelRef } from "../domain/department.model"
import { AxiosRequestConfig } from "axios"
import { ApplicationResponse } from "@src/common/domain/common.model"
export const updateDepartmentList = createAsyncThunk<void, any>("department/updateDepartment",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<NewDepartmentModelRef[]>>(`${AppConstants.api}/department`, payload)
})
export const addDepartmentList = createAsyncThunk<void, any>("department/addDepartment",
 async (payload: any) => {
    const response = await api.post<ApplicationResponse<NewDepartmentModelRef[]>>(`${AppConstants.api}/department`, payload)
})
export const deleteDepartment = createAsyncThunk(
  "department/deleteDepartment",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/department?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchDepartmentList = createAsyncThunk<any[], void> ("department/fetchDepartment",
    async () => {
        const response = await api.get<ApplicationResponse<NewDepartmentModelRef[]>>(`${AppConstants.api}/department`)
        return response.data.data || []  
    })
   
const DepartmentSlice = createSlice({
    name: "department",
    initialState: {minimal: {status: "loading", error: null, data: []}} as DepartmentStore,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDepartmentList.pending, (state, action) => {
                state.minimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(fetchDepartmentList.fulfilled, (state, action) => {
                state.minimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(fetchDepartmentList.rejected, (state, action) => {
                state.minimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })

    }
})

export default DepartmentSlice.reducer
